import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGhostComponent } from './simple-icons-ghost.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGhostComponent ],
    exports:      [ SimpleIconsGhostComponent ],
    bootstrap:    []
})
export class SimpleIconsGhostModule {}
